import { Injectable } from "@angular/core";
import { CtWebapiService, DataRequest } from "@ctsolution/ct-webapi";
import { CtWebapiGenericResponse } from "@ctsolution/ct-webapi/core/response.interface";
import { ISignatureReturnDTO } from "../interfaces/digital-signature-result";
import { ISendSignature, SendSignatureDTO } from "../interfaces/digital-signature-send";
import { SignatureReturnEventDTO } from "../interfaces/digital-signature-event";
import { CheckTokenReturn } from "../interfaces/check-token-return";

@Injectable({
  providedIn: "root"
})
export class DigitalSignatureController {

  private controller: string = "/DocumentSign/";

  constructor(private _webapi: CtWebapiService) {
  }

  activateSignature(parameter: SendSignatureDTO): Promise<ISignatureReturnDTO | null> {

    return new Promise<ISignatureReturnDTO | null>((resolve) => {

      const request: DataRequest = new DataRequest(`${this.controller}ActivateSignature`);

      var a = {
        SignerInfo: parameter.SignerInfo,
        Token: parameter.Token
      }

      this._webapi
        .post(request, a)
        .subscribe((r: CtWebapiGenericResponse<ISignatureReturnDTO | null>) => {

          resolve(r.Result);

        });

    });

  }

  signatureSoftwareEventReturn(parameter: SignatureReturnEventDTO): Promise<SignatureReturnEventDTO | null> {

    return new Promise<SignatureReturnEventDTO | null>((resolve) => {

      const request: DataRequest = new DataRequest(`${this.controller}SignatureSoftwareEventReturn`);

      var a = {
        Token: parameter.token,
        Status: parameter.status,
        Description: parameter.description
      }

      this._webapi
        .post(request, a)
        .subscribe((r: CtWebapiGenericResponse<SignatureReturnEventDTO | null>) => {

          resolve(r.Result);

        });

    });

  }


  checkToken(param: ISendSignature): Promise<CheckTokenReturn> {

    return new Promise<CheckTokenReturn>((resolve) => {
      // Endpoint aggiornato alla versione v2: il backend ora valorizza sempre il Result
      // (sia in caso di token valido che invalido) e include CompanyCode/LabelFileName
      // per la personalizzazione dinamica della UI.
      const request: DataRequest = new DataRequest(`/v2${this.controller}CheckToken`);
      const a = param
  
      this._webapi.post(request, a).subscribe({
        next: (response: CtWebapiGenericResponse<CheckTokenReturn | null>) => {

          if(response.Result == null) {
            // Caso difensivo: Result nullo viene trattato come token non valido con messaggio generico
            resolve(new CheckTokenReturn(false, "Documento non valido o scaduto."));
            return;
          }

          const result = response.Result;

          // Precedenza degli stati:
          //   1) ErrorMessage valorizzato → token non valido, mostra schermata di errore
          //   2) Url valorizzato         → token non valido, mostra modale "procedura interrotta"
          //   3) altrimenti              → token valido, prosegue con il flusso di firma
          //
          // ErrorMessage ha priorità su Url: se entrambi fossero valorizzati,
          // l'Url non viene propagato per evitare che il template entri nel ramo
          // "procedura interrotta" invece di mostrare l'errore.
          if (result.ErrorMessage) {
            resolve(new CheckTokenReturn(
              false,
              result.ErrorMessage,
              undefined,
              result.CompanyCode,
              result.LabelFileName
            ));
            return;
          }

          if (result.Url) {
            resolve(new CheckTokenReturn(
              false,
              undefined,
              result.Url,
              result.CompanyCode,
              result.LabelFileName
            ));
            return;
          }

          resolve(new CheckTokenReturn(
            true,
            undefined,
            undefined,
            result.CompanyCode,
            result.LabelFileName
          ));

        },
        error: () => {
          resolve(new CheckTokenReturn(false, "Non sei autorizzato")); // Se c'è un errore, restituisci false
        }
      });
    });
  }
}
